import { ITableMessage } from 'dromo-uploader-js'

export function validateRequired(value: string): ITableMessage[] {
  if (!value) {
    return [{ message: 'Required', level: 'error' }]
  }
  return []
}

export function validateLength(
  value: string,
  maxLength: number
): ITableMessage[] {
  if (!value || value.length <= maxLength) {
    return []
  }
  return [
    {
      message: `Length must be at most ${maxLength}`,
      level: 'error',
    },
  ]
}
